export default __webpack_public_path__ + "static/media/stomach4.afaa30bf.jpg";